<template>
    <div id="index-heading">
    <link href="https://fonts.googleapis.com/css?family=Roboto+Condensed&amp;display=swap" rel="stylesheet">
    <h1 id="main-heading"> { Noteworthy Projects }
    <hr id="main-rule"></h1>
    <div id="short-paragraph">
        Rapid prototyping is my jam!<br>
        I love experimenting with new technology. <br> 
        Physics and Machine learning are my favourite topics.<br>
        Here are some of my proudest projects:
    </div>
    <br>
    <br>
    </div>
</template>

<script>
export default {
  name: 'IndexHeading',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#index-heading{
    color: white;
    text-align: center;
    font-family: 'Roboto Condensed', sans-serif;
    }
 #main-heading{
     font-size: 5rem;
     margin: 0px;
 }
 #main-rule{
     width:20rem; 
     margin-top: 1rem;
     border-top: white;
 }
 #short-paragraph{
    word-wrap: break-word; 
    max-width: 30rem; 
    display: inline-block;
 }

</style>
